"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var react_i18next_1 = require("react-i18next");
var styles_1 = __importDefault(require("../../styles"));
exports.default = (function (_a) {
    var onApply = _a.onApply, onReset = _a.onReset;
    var _b = __read(react_i18next_1.useTranslation(), 1), t = _b[0];
    var classes = styles_1.default();
    return (react_1.default.createElement(core_1.Grid, { container: true, item: true, justify: "flex-end", alignItems: "center", className: classes.footer },
        react_1.default.createElement(core_1.Grid, { item: true, className: classes.buttonGrid },
            react_1.default.createElement(core_1.Button, { color: "primary", className: classes.resetButton, onClick: onReset }, t('button.reset'))),
        react_1.default.createElement(core_1.Grid, { item: true, className: classes.buttonGrid },
            react_1.default.createElement(core_1.Button, { color: "primary", variant: "contained", className: classes.applyButton, onClick: onApply }, t('button.apply')))));
});
